/**
 * Payment Type Enum
 */
export enum PaymentType {
    /**
     * During Drop Off
     */
    DURING_DROP_OFF = 'DuringDropOff',
    /**
     * During Pick Up
     */
    DURING_PICK_UP = 'DuringPickUp',
    /**
     * No Payment
     */
    NO_PAYMENT = 'NoPayment',
    /**
     * Subscription
     */
    SUBSCRIPTION = 'Subscription'
}